import { render, staticRenderFns } from "./vExhibitsDetail.vue?vue&type=template&id=651865fc&scoped=true"
import script from "./vExhibitsDetail.vue?vue&type=script&lang=js"
export * from "./vExhibitsDetail.vue?vue&type=script&lang=js"
import style0 from "./vExhibitsDetail.vue?vue&type=style&index=0&id=651865fc&prod&lang=stylus"
import style1 from "./vExhibitsDetail.vue?vue&type=style&index=1&id=651865fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651865fc",
  null
  
)

export default component.exports